import React, { useState, useMemo } from 'react';
import MaterialTable from 'material-table'
import { withStyles, Typography, IconButton, Tooltip } from '@material-ui/core';
import * as auditRecordActions from './store/watchProductAuditRecordActions';
import * as action from '../../np-core/Auth/store/authActions';
import { connect } from 'react-redux';
import { Delete, Refresh } from '@material-ui/icons';
import NICDelete from '../NIC/NICDelete'
import { hasPermission, localization, hasAtLeastOnePermission } from '../../sc-utilities';
import Toolbar from '../../sc-utilities/Toolbar'
import { MuiTableRows } from '../../../themes';

const styles = theme => ({
    "@global": {
        "[class*='buttonsCustomer']": {
            margin: theme.spacing(),
            fontSize: '13px',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.buttonText.default
            },
        },
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.buttonText.default,
            margin: theme.spacing(),
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
    },
    fab: {
        textTransform: "none",
        width: '50%',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    customToolbar: {
        marginTop: 15,
        marginLeft: 14,
        width: "900px"
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    },
    toolbar: {
        paddingTop: '1%'
    }
});
let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const WatchProductAuditRecordList = props => {
    const { classes, translations, onBulkDeleteWatchProductAuditRecords, editable, saveColumnsFilter, onFetchWatchProductAuditRecordsCount, activeCustomer, permissions, tableColumns, onFetchWatchProductAuditRecords, tableRef, productID } = props;
    const [deleteModalState, setDeleteModalState] = useState({ open: false, ids: [] });

    const columnObject = useMemo(() => tableColumns, [tableColumns]);

    const [tableOptions, setTableOptions] = useState({
        filtering: true,
        sorting: false,
        selection: hasAtLeastOnePermission(permissions, ["product_audit_record_delete"]),
        search: false,
        minBodyHeight: window.innerHeight - 320 < 250 ? 250 : window.innerHeight - 320,
        maxBodyHeight: window.innerHeight - 320,
        pageSizeOptions: rowsPageSizeInit,
        rowStyle: (_rowData, index) => {
            return { backgroundColor: index % 2 ? MuiTableRows.odd : MuiTableRows.even };
        },
        columnsButton: true,
        pageSize: pageSize ? pageSize : 50,
        emptyRowsWhenPaging: false
    });

    const handleBulkDelete = ids => {
        if (!ids) {
            setDeleteModalState({ open: false, ids: [] });
            return;
        }
        setDeleteModalState({ open: true, ids });
    };

    const tableActions = [
        {
            tooltip: `${translations["remove_all_selected"] || "Remove All Selected "} ${translations["audit_records"] || "Audit Records"}`,
            icon: <Delete />,
            onClick: (rowData) => handleBulkDelete(rowData.map(data => data.ProductAuditRecordID)),
            position: 'toolbarOnSelect',
        }
    ]

    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    }
    async function fetchTableData(query) {
        let q = filterQuery(query.filters);
        query['ActiveCustomerID'] = activeCustomer;
        query['ProductID'] = productID;
        query['q'] = q;
        const count = await onFetchWatchProductAuditRecordsCount(query);
        const result = count ? await onFetchWatchProductAuditRecords(query) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result || [], page: query.page, pageSize: pageSize, totalCount: count };
    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`AuditRecord`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomer })
        return newColumnState;
    }

    const handleCloseDanger = async () => {
        await onBulkDeleteWatchProductAuditRecords({ ProductAuditRecordIDs: deleteModalState.ids, ActiveCustomerID: activeCustomer });
        handleBulkDelete();
        tableRef.current && tableRef.current.onQueryChange();
    }

    const tableTitle = () => {
        return <div className={classes.customToolbar}>
            <div className={classes.tableTitle}>
                <Typography className={classes.typography}>{translations["audit_record"] || "Audit Record"}</Typography>
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    }
    return (<>
        <MaterialTable
            tableRef={tableRef}
            title={tableTitle()}
            components={{
                Toolbar: props => (
                    <Toolbar data={props} classes={{ toolbar: classes.toolbar }} actions={tableActions} selectedRows={props.selectedRows} editable={!editable} translations={translations} />
                )
            }}
            columns={columnObject}
            data={fetchTableData}
            options={tableOptions}
            onChangeRowsPerPage={(size) => {
                pageSize = size
            }}
            onChangeColumnHidden={columnHidden}
            actions={tableActions}
            localization={localization(translations)}
            onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
        />
        {hasPermission(permissions, "product_audit_record_delete") ? (
            <NICDelete
                activeCustomer={activeCustomer}
                entityName={translations["audit_records"] || "Audit Records"}
                translations={translations}
                handleCloseDanger={handleCloseDanger}
                handleDelete={handleBulkDelete}
                deleteModalState={deleteModalState}
            />
        ) : null}
    </>)
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchWatchProductAuditRecordsCount: filter => dispatch(auditRecordActions.onFetchWatchProductAuditRecordsCount(filter)),
        onFetchWatchProductAuditRecords: filter => dispatch(auditRecordActions.onFetchWatchProductAuditRecords(filter)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        onBulkDeleteWatchProductAuditRecords: data => dispatch(auditRecordActions.bulkDeleteWatchProductAuditRecords(data))
    };
};

const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(WatchProductAuditRecordList));